<div class="">
  <div class="form-header">
    <button clickable class="btn-close" (click)="gotoLanding()">
      <img
        src="./assets/images/left-arrow-active.svg"
        alt="arrow"
      />
    </button>
    
    <h2 class="form-title">{{cardDetails.requestTypeDesc}}</h2>
  </div>

  <div class="tab-bar-container">
      <div>
          <app-h-tab-bar [tabs]="settingsTabList" (onSelectTab)="onSelectTab($event)"></app-h-tab-bar>
      </div>
  </div>

  <div class="service-request-status-container" [hidden]="!(tabToShow == 'status')">
    <div class="service-request-card">
        <app-service-request [serviceRequest]="cardDetails"></app-service-request>
    </div>
    <div class="tracker-status" *ngFor="let item of this.serviceRequestStages; let index=i">
        <app-service-request [serviceRequest]="item"></app-service-request>
    </div>
  </div>
  
  <div class="form-body" [hidden]="!(tabToShow == 'request')">
    <ng-container *ngIf="_commonService.isMobile(); else mobileView">
      <router-outlet></router-outlet>
    </ng-container>
    <ng-template #mobileView containerRef></ng-template>
  </div>
</div>


